<div class="product_download-section fluad-rwe-download" *ngIf="thirdnode | async as item">
    <div class="container">
        <div class="product_download-sectionCont">
            <span class="product_download-paraspan" [innerHTML]="item.content"></span>                       
        </div>
    </div>
</div>

<div class="product_download-greysection" *ngIf="thirdnode | async as item">
    <div class="container">
        <div class="product_greysection">
            <div class="pull-left" [innerHTML]="item.headLine"></div>
            <a [href]="getpdf(item?.mediaPdf)" target="_blank" class="product_download-button pull-right">
                <span>{{item.pdfText}}</span>
                <img alt="Download" src="../../../assets/images/product_download_icon.svg">
            </a>
            <div class="clearboth"></div>
        </div>
    </div>
</div>